import { render, staticRenderFns } from "./MessageBadge.vue?vue&type=template&id=d8534266&scoped=true&"
import script from "./MessageBadge.vue?vue&type=script&lang=js&"
export * from "./MessageBadge.vue?vue&type=script&lang=js&"
import style0 from "./MessageBadge.vue?vue&type=style&index=0&id=d8534266&lang=sass&scoped=true&"
import style1 from "./MessageBadge.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8534266",
  null
  
)

export default component.exports